module.exports = __webpack_public_path__ + "static/dash-1cf4c9bc8d428a48ea383fa977f47af9.png";